import { segmentedControlSizes } from '@shared/config/components/segmentedControl'
import { typographyRemSizes } from '../theme'

export const getSegmentedControlItemTextSize = (
  size: keyof typeof segmentedControlSizes,
  hasIcon: boolean
): keyof typeof typographyRemSizes['size'] => {
  if (size === 'm' && !hasIcon) {
    return 'captionL'
  }

  if (size === 'm') {
    return 'captionM'
  }

  return 'captionS'
}
